module.exports = __webpack_public_path__ + "static/media/spinSlow.329c2e4f.mp3";